import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import '../styles/StarRating.css';

const StarRating = ({
  rating = 0,
  maxRating = 5,
  size = 'medium',
  editable = false,
  onChange = null,
  showCount = false,
  count = 0
}) => {
  const { t } = useTranslation();
  const [hoverRating, setHoverRating] = useState(0);

  const handleClick = (value) => {
    if (editable && onChange) {
      onChange(value);
    }
  };

  const handleMouseEnter = (value) => {
    if (editable) {
      setHoverRating(value);
    }
  };

  const handleMouseLeave = () => {
    if (editable) {
      setHoverRating(0);
    }
  };

  const displayRating = hoverRating || rating;

  return (
    <div className={`star-rating ${size} ${editable ? 'editable' : ''}`}>
      <div className="stars">
        {[...Array(maxRating)].map((_, index) => {
          const value = index + 1;
          const isFilled = value <= displayRating;
          const isHalf = !isFilled && value - 0.5 <= displayRating;

          return (
            <span
              key={index}
              className={`star ${isFilled ? 'filled' : ''} ${isHalf ? 'half' : ''}`}
              onClick={() => handleClick(value)}
              onMouseEnter={() => handleMouseEnter(value)}
              onMouseLeave={handleMouseLeave}
            >
              ★
            </span>
          );
        })}
      </div>
      {showCount && (
        <span className="rating-count">
          {rating > 0 ? `${rating.toFixed(1)}` : ''} {t('reviews.reviewCount', { count })}
        </span>
      )}
    </div>
  );
};

export default StarRating;
